const actionTypes = {
  OPEN_DIALOG: "OPEN_DIALOG",
  CLOSE_DIALOG: "CLOSE_DIALOG",
  SET_QUERY_PARAMS: "SET_QUERY_PARAMS",
  RESET_QUERY_PARAMS: "RESET_QUERY_PARAMS",
  LOGIN_SET_QUERY_PARAMS: "LOGIN_SET_QUERY_PARAMS",
  OPEN_TOASTER: "OPEN_TOASTER",
  CLOSE_TOASTER: "CLOSE_TOASTER",
  CLOSE_ALL_TOASTERS: "CLOSE_ALL_TOASTERS",
  CLOSE_MODAL: "CLOSE_MODAL",
  SET_ACTUAL_LANGUAGE: "SET_ACTUAL_LANGUAGE",
  RESET_ACTUAL_LANGUAGE: "RESET_ACTUAL_LANGUAGE",

  GET_MESSAGES_REQUEST: 'GET_MESSAGES_REQUEST',
  GET_MESSAGES_SUCCESS: 'GET_MESSAGES_SUCCESS',
  READ_MESSAGE_REQUEST: 'READ_MESSAGE_REQUEST',
  READ_MESSAGE_SUCCESS: 'READ_MESSAGE_SUCCESS',

  SET_GAME_URL: 'SET_GAME_URL',
  RESET_GAME_URL: 'RESET_GAME_URL',
  REQUEST_GAME_URL: 'REQUEST_GAME_URL',
  FAIL_GAME_URL: 'FAIL_GAME_URL',

  SET_GAME_BOX_MISSION_COUNT: 'SET_GAME_BOX_MISSION_COUNT',
  RESET_GAME_BOX_MISSION_COUNT: 'RESET_GAME_BOX_MISSION_COUNT',

  SET_GAME_INFO: 'SET_GAME_INFO',
  RESET_GAME_INFO: 'RESET_GAME_INFO',


  SAVE_TEMPLATE_MSG_SUCCESS: 'SAVE_TEMPLATE_MSG_SUCCESS',
  SAVE_TEMPLATE_MSG_FAILURE : 'SAVE_TEMPLATE_MSG_FAILURE',

  GAME_BOX_MISSION_REQUEST: 'GAME_BOX_MISSION_REQUEST',
  GAME_BOX_MISSION_SUCCESS: 'GAME_BOX_MISSION_SUCCESS',
  GAME_BOX_MISSION_UPDATE: 'GAME_BOX_MISSION_UPDATE',
  GAME_BOX_MISSION_FAIL: 'GAME_BOX_MISSION_FAIL',
  GAME_BOX_JACKPOT_SUCCESS: 'GAME_BOX_JACKPOT_SUCCESS',
  GAME_BOX_JACKPOT_FAIL: 'GAME_BOX_JACKPOT_FAIL',
  GAME_BOX_JACKPOT_TICKETS_SUCCESS: 'GAME_BOX_JACKPOT_TICKETS_SUCCESS',
  GAME_BOX_JACKPOT_TICKETS_REQUEST: 'GAME_BOX_JACKPOT_TICKETS_REQUEST',
  GAME_BOX_JACKPOT_REQUEST: 'GAME_BOX_JACKPOT_REQUEST',
  GAME_BOX_JACKPOT_UPDATE_REQUEST: 'GAME_BOX_JACKPOT_UPDATE_REQUEST',
  GAME_BOX_JACKPOT_UPDATE: 'GAME_BOX_JACKPOT_UPDATE',
  GAME_BOX_JACKPOT_RESET_PREV_DATA: 'GAME_BOX_JACKPOT_RESET_PREV_DATA',
  SET_GAME_BOX_TAG: 'SET_GAME_BOX_TAG',

  CASINO_TOURNAMENT_NEXT_INSTANCE_REQUEST: 'CASINO_TOURNAMENT_NEXT_INSTANCE_REQUEST',
  CASINO_TOURNAMENT_NEXT_INSTANCE_SUCCESS: 'CASINO_TOURNAMENT_NEXT_INSTANCE_SUCCESS',
  CASINO_TOURNAMENT_NEXT_INSTANCE_UPDATE: 'CASINO_TOURNAMENT_NEXT_INSTANCE_UPDATE',
  CASINO_TOURNAMENT_NEXT_INSTANCE_FAILURE: 'CASINO_TOURNAMENT_NEXT_INSTANCE_FAILURE',
  CASINO_TOURNAMENT_NEXT_INSTANCE_RESET_PREV_DATA: 'CASINO_TOURNAMENT_NEXT_INSTANCE_RESET_PREV_DATA',
  CASINO_TOURNAMENT_NEXT_INSTANCES: 'CASINO_TOURNAMENT_NEXT_INSTANCES',

  MISSION_REQUEST: 'MISSION_REQUEST',
  MISSION_SUCCESS: 'MISSION_SUCCESS',
  MISSION_FAIL: 'MISSION_FAIL',
  MISSION_UPDATE: 'MISSION_UPDATE',
  UPDATE_MISSION_TOTAL_WIN_AND_FREE_SPIN_COUNT: 'UPDATE_MISSION_TOTAL_WIN_AND_FREE_SPIN_COUNT',

  TOURNAMENT_GAME_URL_REQUEST: 'TOURNAMENT_GAME_URL_REQUEST',
  TOURNAMENT_GAME_URL_SUCCESS: 'TOURNAMENT_GAME_URL_SUCCESS',
  TOURNAMENT_GAME_URL_FAIL: 'TOURNAMENT_GAME_URL_FAIL',
  SET_EXTERNAL_TOURNAMENT_GAME: 'SET_EXTERNAL_TOURNAMENT_GAME',
  RESET_EXTERNAL_TOURNAMENT_GAME: 'RESET_EXTERNAL_TOURNAMENT_GAME',

  FREESPINS_WAGERING_GAMES_REQUEST: 'FREESPINS_WAGERING_GAMES_REQUEST',
  FREESPINS_GAMES_SUCCESS: 'FREESPINS_GAMES_SUCCESS',
  FREESPINS_WAGERING_GAMES_FAIL: 'FREESPINS_WAGERING_GAMES_FAIL',

  PROGRESSIVE_MISSIONS_REQUEST: 'PROGRESSIVE_MISSIONS_REQUEST',
  PROGRESSIVE_MISSIONS_SUCCESS: 'PROGRESSIVE_MISSIONS_SUCCESS',
  PROGRESSIVE_MISSIONS_FAIL: 'PROGRESSIVE_MISSIONS_FAIL',
  PROGRESSIVE_MISSIONS_UPDATE: 'PROGRESSIVE_MISSIONS_UPDATE',
  PROGRESSIVE_MISSIONS_CHAIN_UPDATE: 'PROGRESSIVE_MISSIONS_CHAIN_UPDATE',
  TOGGLE_PROGRESSIVE_MISSIONS_ANIMATION: 'TOGGLE_PROGRESSIVE_MISSIONS_ANIMATION',

  EXPIRED_PROGRESSIVE_MISSIONS_REQUEST: 'EXPIRED_PROGRESSIVE_MISSIONS_REQUEST',
  EXPIRED_PROGRESSIVE_MISSIONS_SUCCESS: 'EXPIRED_PROGRESSIVE_MISSIONS_SUCCESS',
  EXPIRED_PROGRESSIVE_MISSIONS_CLEAR: 'EXPIRED_PROGRESSIVE_MISSIONS_CLEAR',

  TOGGLE_AVAILABLE_GAMES_LIST: 'TOGGLE_AVAILABLE_GAMES_LIST',
  CHANGE_GAME_BOX_VIEW: 'CHANGE_GAME_BOX_VIEW',
  CHANGE_GAME_BOX_KYC: 'CHANGE_GAME_BOX_KYC',
  CHANGE_GAME_BOX_LIMITS: 'CHANGE_GAME_BOX_LIMITS',

  TOGGLE_RAFFLE_DRAW_RULES: 'TOGGLE_RAFFLE_DRAW_RULES',
  SET_RAFFLE_DRAW_VIEW: 'SET_RAFFLE_DRAW_VIEW',

  RACES_REQUEST: 'RACES_REQUEST',
  RACES_FAILURE: 'RACES_FAILURE',
  RACES_SUCCESS: 'RACES_SUCCESS',

  MINI_GAMES_REQUEST: 'MINI_GAMES_REQUEST',
  MINI_GAMES_SUCCESS: 'MINI_GAMES_SUCCESS',
  MINI_GAMES_FAILURE: 'MINI_GAMES_FAILURE',

  JOIN_TO_SPORT_REQUEST: 'JOIN_TO_SPORT_REQUEST',
  JOIN_TO_SPORT_FAILURE: 'JOIN_TO_SPORT_FAILURE',

  RACES_LEADERBOARD_REQUEST: 'RACES_LEADERBOARD_REQUEST',
  RACES_LEADERBOARD_FAILURE: 'RACES_LEADERBOARD_FAILURE',
  RACES_LEADERBOARD_SUCCESS: 'RACES_LEADERBOARD_SUCCESS',
  RACES_LEADERBOARD_RESET: 'RACES_LEADERBOARD_RESET',
  RACES_LEADERBOARD_LOADER: 'RACES_LEADERBOARD_LOADER',

  JOIN_TO_RACE_REQUEST: 'JOIN_TO_RACE_REQUEST',
  JOIN_TO_RACE_FAILURE: 'JOIN_TO_RACE_FAILURE',
  JOIN_TO_RACE_SUCCESS: 'JOIN_TO_RACE_SUCCESS',

  OPT_TO_MISSION_REQUEST: 'OPT_TO_MISSION_REQUEST',
  OPT_TO_MISSION_FAILURE: 'OPT_TO_MISSION_FAILURE',

  FIRST_DEPOSIT_TO_BONUS_REQUEST: 'FIRST_DEPOSIT_TO_BONUS_REQUEST',
  FIRST_DEPOSIT_TO_BONUS_FAILURE: 'FIRST_DEPOSIT_TO_BONUS_FAILURE',
  FIRST_DEPOSIT_TO_BONUS_SUCCESS: 'FIRST_DEPOSIT_TO_BONUS_SUCCESS',

  UPDATE_JOIN_TO_RACE_PENDING_STATUS: 'UPDATE_JOIN_TO_RACE_PENDING_STATUS',

  RAFFLE_DRAW_RULES_REQUEST: 'RAFFLE_DRAW_RULES_REQUEST',
  RAFFLE_DRAW_RULES_SUCCESS: 'RAFFLE_DRAW_RULES_SUCCESS',
  RAFFLE_DRAW_RULES_FAILURE: 'RAFFLE_DRAW_RULES_FAILURE',
};

export default actionTypes;
